import $ from 'jquery';
import 'waypoints/lib/jquery.waypoints.min.js';

const init = () => {
  // waypoints added to we can apply animation to sections
  // just add .js-reveal to the section you wish to check and it'll apply a 'js-animate' when in the view

  $('.js-reveal').waypoint({
    handler: function (direction) {
      if (direction === 'down') {
        $(this.element).addClass('js-animate');
        this.destroy();
      }
    },
    offset: '75%',
  });

  // we need to apply a focusin/focusoutto cards due to the way the links are applied
  // we are attaching a class which in turn allows us to hook up some CSS
  $('.js-card').focusin(() => {
    $(this).addClass('on-focus');
  });

  $('.js-card').focusout(() => {
    $(this).removeClass('on-focus');
  });

  // fix for Umbraco forms single checkbox element to enable custom styling
  // also places the label to the right of the checkbox instead of above it
  $('.umbraco-forms-field.checkbox').each((index, el) => {
    let $this = $(el);
    $this.find('label').insertAfter($this.find('input'));
  });

  // sticky CTA button
  $('.btn-sticky-wrapper').waypoint({
    handler: function (direction) {
      console.log(direction);
      if (direction === 'down') {
        $('.btn-sticky-wrapper').addClass('btn-sticky-wrapper--fixed');
        $('body').addClass('sticky-button-fixed');
      } else {
        $('.btn-sticky-wrapper').removeClass('btn-sticky-wrapper--fixed');
        $('body').removeClass('sticky-button-fixed');
      }
    },
    offset: function () {
      // waypoint should be handled when the button hits the bottom of the header
      return $('.header').height();
    },
  });
  const btnStickyWrapperTopPosition = () =>
    $('.btn-sticky-wrapper').css({
      top: window.innerWidth > 991 ? `${$('.header').height() + $('.promotional-banner').height()}px` : '',
    });
  window.addEventListener('resize', btnStickyWrapperTopPosition);
  btnStickyWrapperTopPosition();
};

export { init };
